import styled from "styled-components";
import { Typography } from "antd";
import { TitleProps } from "antd/es/typography/Title";

export const Title = styled(Typography.Title)<TitleProps>`
  color: ${({ theme }) => theme.colors.blueDianne} !important;
`;
